// extracted by mini-css-extract-plugin
export var avatarContainer = "_bz-0";
export var avatarTypingWave = "_bz-i";
export var gray = "_bz-f";
export var green = "_bz-c";
export var icon = "_bz-9";
export var image = "_bz-1";
export var lg = "_bz-6";
export var md = "_bz-5";
export var presenceDot = "_bz-b";
export var red = "_bz-d";
export var sm = "_bz-4";
export var status = "_bz-a";
export var typingDot = "_bz-h";
export var typingPill = "_bz-g";
export var xl = "_bz-7";
export var xs = "_bz-3";
export var xxl = "_bz-8";
export var xxs = "_bz-2";
export var yellow = "_bz-e";